function getValue(object, path) {
  return path
    .replace(/\[/g, '.')
    .replace(/\]/g, '')
    .split('.')
    .reduce((o, k) => (o || {})[k], object)
}

function get(object, path, defaultValue) {

  const result = object == null ? undefined : getValue(object, path)
  return result === undefined ? defaultValue : result
}

export const path = (pathString, object) => (
  pathString
    .split('.')
    .reduce((obj, key) => obj[key] === undefined ? undefined : obj[key], object)
)

export const shallowEquals = (a, b, ...keys) =>
  (keys.length ? keys : Object.keys(a)).every(key => a[key] === b[key])

export default {
  path,
  get,
  shallowEquals
}



// WEBPACK FOOTER //
// ./src/utils/object.js